import request from '@/utils/request';
export function getMessageList(data) {
    return request({
        url: `/system/message/getMessageList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'post',
        data,
    })
}

export function getReceiveMessageListCount() {
    return request({
        url: `/system/message/getReceiveMessageListCount`,
        method: 'post',
        data:  {},
    })
}

export function updateReceiveStatus(data) {
    return request({
        url: `/system/message/updateReceiveStatus`,
        method: 'post',
        data,
    })
}

export function notificationQuery(data) {
    return request({
        url: `/system/notification/page-query`,
        method: 'post',
        data,
    })
}
export function notificationRead(data) {
    return request({
        url: `/system/notification/mark-as-read`,
        method: 'post',
        data
    })
}

export function notificationCount() {
    return request({
        url: `/system/notification/count-unread`,
        method: 'post',
    })
}


